import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/pernyataan-kenaikan-kelas", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/pernyataan-kenaikan-kelas/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/pernyataan-kenaikan-kelas`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function prefill(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/pernyataan-kenaikan-kelas-prefill`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/pernyataan-kenaikan-kelas/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function sign(id: number) {
  const response = await http.postData(`/pernyataan-kenaikan-kelas/${id}/sign`, {}).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/pernyataan-kenaikan-kelas/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/pernyataan-kenaikan-kelas/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  prefill,
  find,
  sign,
  destroy,
  print
};
